import { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

import { GuaranteePageContent } from './shipsticks.page.content'

const BACKGROUND_IMAGE = '/images/shipskis/guarantee-hero.jpg'

const hero: NarrativeHeroProps = {
  backgroundImage: BACKGROUND_IMAGE,
  header: 'The ShipSkis Guarantee',
  subHeader: 'Our service is game-changing. You’ll never lug again.',
}

interface FiftyFiftyTextFields {
  header: string
  subHeader: string
  image: string
  body: React.ReactNode
}

const commonFiftyFiftyProps = {
  backgroundColor: 'grey' as 'white' | 'grey',
  showEyebrow: false,
}

const fiftyTexts: FiftyFiftyTextFields[] = [
  {
    header: 'On-Time',
    subHeader: 'You’re not just shipping a bag. You’re protecting your trip.',
    image: '/images/shipskis/guarantee-1.jpg',
    body: (
      <>
        <p>
          Our powerful network outperforms even the biggest logistics companies, resulting in the
          industry’s best on-time rates. Your skis are guaranteed to arrive when you need them.
        </p>
      </>
    ),
  },
  {
    header: 'Easy',
    subHeader: 'It’s ski travel, down to a science.',
    image: '/images/shipskis/guarantee-2.jpg',
    body: (
      <>
        <p>
          From booking to delivery, every step is designed for convenience. No lugging, no waiting,
          no guesswork—just a seamless way to get your luggage where it needs to go, without lifting
          a finger.
        </p>
      </>
    ),
  },
  {
    header: 'Insured',
    subHeader: 'Your gear travels better than you do.',
    image: '/images/shipskis/guarantee-3.jpg',
    body: (
      <>
        <p>
          For added peace of mind, every shipment comes with complimentary coverage with the option
          to insure for more. Plus, you can stay informed with anytime access to real-time tracking,
          along with delivery notifications right to your inbox or by text.
        </p>
      </>
    ),
  },
  {
    header: 'On your terms',
    subHeader: 'Your trip, your way.',
    image: '/images/shipskis/guarantee-4.jpg',
    body: (
      <>
        <p>
          Have your gear picked up from your home or office, or from your resort or mountain at the
          end of your trip. Have a change of plans? Want to squeeze in another day? No problem.
          Easily adjust your booking online or over the phone.
        </p>
      </>
    ),
  },
  {
    header: 'Expert',
    subHeader: 'Customer support that speaks fluent ski.',
    image: '/images/shipskis/guarantee-5.jpg',
    body: (
      <>
        <p>
          We don’t do long hold times or confusing call trees. Our dedicated US-based support team
          is available seven days a week (yes, even on weekends) to make sure you get the answers
          you need, when you need them.
        </p>
      </>
    ),
  },
  {
    header: 'International',
    subHeader: 'We go wherever the mountains call you.',
    image: '/images/shipskis/guarantee-6.jpg',
    body: (
      <>
        <p>
          We service 180 countries and territories, and handle all the tricky customs paperwork. The
          days of dragging your travel bag through unfamiliar cities, packed subways, and endless
          customs lines? Long gone.
        </p>
      </>
    ),
  },
  {
    header: 'Trusted',
    subHeader: 'By ski pros, your powder-chasing buddies, and beyond.',
    image: '/images/shipskis/guarantee-7.jpg',
    body: (
      <>
        <p>
          We’ve spent over a decade working closely with major carriers like FedEx and UPS to ensure
          your luggage is transported safely and reliably. The result? Millions of happy travelers
          and thousands of partnerships with iconic destinations.
        </p>
      </>
    ),
  },
]

const fifties: FiftyFiftyProps[] = fiftyTexts.map((text, index) => ({
  ...text,
  image: {
    src: text.image,
    alt: text.header,
  },
  layout: index % 2 === 0 ? 'image-right' : 'image-left',
  ...commonFiftyFiftyProps,
}))

const header: string = `
  We’re here to make ski travel easier, more reliable, and way less stressful.
  That’s why every shipment is backed by the ShipSkis guarantee.
`

const subHeader: string = `Here’s what that means for you:`

const content: GuaranteePageContent = {
  hero,
  fifties,
  header,
  subHeader,
}

export default content
